import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

const Text = styled.a`
  font-size: 1rem;
  padding-top: 15px;
  font-weight: 600;
  cursor: pointer;

  @media (max-width: 500px) {
    display: block;
    width: 100%;
    margin-bottom: 15px;
    padding-left: 25px;
  }
`;

interface Props {
  clickFn: () => void;
  children: ReactNode;
  className: string;
}

export const EnabledTextButton = (props: Props) => {
  return <Text className={props.className} onClick={props.clickFn}>{props.children}</Text>;
};

export default EnabledTextButton;
